import { useLanguage } from "@/contexts/LanguageContext";

const marqueeItems = {
  de: ["Aufstockungen & Anbauten", "Dachstühle & Holztragwerke", "Holzfassaden", "Holzhäuser",
       "Hotelbau", "Sanierungen & Restaurierungen", "Hallen & Gewerbebauten", "Terrassen & Balkone",
       "Seit 1962", "Meran · Südtirol"],
  it: ["Sopraelevazioni & Ampliamenti", "Capriate & Strutture in Legno", "Facciate in Legno",
       "Case in Legno", "Edilizia Alberghiera", "Risanamenti & Restauri",
       "Capannoni Industriali", "Terrazze & Balconi", "Dal 1962", "Merano · Alto Adige"],
};

export function MarqueeSection() {
  const { lang } = useLanguage();
  const items = marqueeItems[lang];
  return (
    <section data-testid="trust-bar" className="overflow-hidden py-4"
      style={{ background: "#111318", borderTop: "1px solid rgba(245,200,0,0.12)", borderBottom: "1px solid rgba(245,200,0,0.12)" }}>
      <div className="marquee-track">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="whitespace-nowrap flex items-center gap-5 pr-8 text-[10px] tracking-[0.22em] uppercase font-inter"
            style={{ color: "rgba(245,200,0,0.45)" }}>
            {item}
            <span className="w-1 h-1 rounded-full flex-shrink-0" style={{ background: "rgba(245,200,0,0.35)" }} />
          </span>
        ))}
      </div>
    </section>
  );
}
